const CUSTOM_PROPERTY_REGEX = /^--/;
const DEFAULT_STYLES = document.createElement("div").style;
const VENDOR_PREFIXES = ["-webkit-", "-moz-", "-o-", "-ms-"];
const propertyNameCache = {};
const IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;
const DIRECTLY_ACCESSIBLE_SETTERS = /scroll(Top|Left)/i;
const HAS_PIXELS_UNIT = /px$/;
function normalizeProperty(property) {
    if (propertyNameCache[property]) {
        return propertyNameCache[property];
    }
    if (property in DEFAULT_STYLES) {
        return property;
    }
    for (let i = 0; i < VENDOR_PREFIXES.length; i++) {
        const prefixedName = `${VENDOR_PREFIXES[i]}${property}`;
        if (prefixedName in DEFAULT_STYLES) {
            propertyNameCache[property] = prefixedName;
            return prefixedName;
        }
    }
    propertyNameCache[property] = property;
    return property;
}
export function setStyles(elements, styles) {
    let styledElements = Array.isArray(elements) ? elements : [elements];
    for (let i = 0; i < styledElements.length; i++) {
        let element = styledElements[i];
        let style = element.style;
        for (let property in styles) {
            let value = styles[property];
            if (DIRECTLY_ACCESSIBLE_SETTERS.test(property)) {
                element[property] = value;
                continue;
            }
            if (CUSTOM_PROPERTY_REGEX.test(property)) {
                style.setProperty(property, value);
                continue;
            }
            if (typeof styles[property] === "number" && !IS_NON_DIMENSIONAL.test(property)) {
                value += "px";
            }
            property = normalizeProperty(property);
            style[property] = value;
        }
    }
}
function getComputedStyles(element, pseudoElement = null) {
    let view = null !== element.ownerDocument && element.ownerDocument.defaultView;
    if (!view || !view.opener) {
        view = window;
    }
    return view.getComputedStyle(element, pseudoElement);
}
export function getStyle(element, property, pseudoElement = null) {
    let castedElement = element;
    if (DIRECTLY_ACCESSIBLE_SETTERS.test(property)) {
        return castedElement[property];
    }
    if (!CUSTOM_PROPERTY_REGEX.test(property)) {
        property = normalizeProperty(property);
    }
    const styles = getComputedStyles(castedElement, pseudoElement);
    const value = styles.getPropertyValue(property) || styles[property];
    if ("opacity" === property) {
        return value === "" ? "1" : value;
    }
    if (value !== undefined && !IS_NON_DIMENSIONAL.test(property) && HAS_PIXELS_UNIT.test(value)) {
        return parseInt(value.replace(HAS_PIXELS_UNIT, ""), 10);
    }
    return value;
}
function updateDisplay(element, style) {
    const list = Array.isArray(element) ? element : [element];
    for (let i = 0; i < list.length; i++) {
        list[i].style.display = style;
    }
}
export function hide(element) {
    updateDisplay(element, "none");
}
export function show(element) {
    updateDisplay(element, "");
}
export function position(element) {
    return {
        top: element.offsetTop,
        left: element.offsetLeft,
    };
}
export function offset(element) {
    const rect = element.getBoundingClientRect();
    return {
        top: rect.top + document.body.scrollTop,
        left: rect.left + document.body.scrollLeft,
    };
}
